export const formatPhoneNumber = (phoneNumber: string, delimiter: " " | "-" = "-") => {
  if (phoneNumber != null) {
    const spacelessPhoneNumber = `${phoneNumber}`.replace(/\s/g, "");
    // If in 10-digit format, then delimit segments...
    if (spacelessPhoneNumber.length === 10) {
      const areaCode = spacelessPhoneNumber.substring(0, 3);
      const prefix = spacelessPhoneNumber.substring(3, 6);
      const lineNumber = spacelessPhoneNumber.substring(6, 10);
      return `${areaCode}${delimiter}${prefix}${delimiter}${lineNumber}`;
    }
  }
  // Otherwise, display as-is...
  return phoneNumber;
};
